export const SUPPORT_EMAIL = 'support@nutrisense.io'

export enum Roles {
  ADMIN = 'admin',
  USER = 'user',
}
